import { kavaProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/kava/default-constants';

export const ELK_CONTRACT_ADDRESS = '0x7a2c1D96C76B6EB62241df4d2fAEb9F0D3D59E10';

export const ELK_PROVIDER_CONFIGURATION = kavaProviderConfiguration;
